import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_10: FaireProductEntity = {
  token: "caden-lane-10",
  type: "product",
  name: "Large Cuddle Plush Friends | Tex T-Rex",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/5425ebf318d3e822286562241749c8099133b2e19bfe29124c3092044fd18fe0.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 22,
  msrpDollars: 44,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
